import { getTextColor } from '../HelperMethods'
import * as sRGB from 'vuetify/src/util/color/transformSRGB'
import * as LAB from 'vuetify/src/util/color/transformCIELAB'
import { colorToInt, intToHex } from 'vuetify/src/util/colorUtils'
import MaterialColors from 'vuetify/es5/util/colors'
import { mapState } from 'vuex'

const Colors = {
  data () {
    return {}
  },
  methods: {
    getTextColor (value) {
      return getTextColor(value)
    },
    lightenColor (value, amount) {
      const lab = LAB.fromXYZ(sRGB.toXYZ(colorToInt(value)))
      lab[0] = lab[0] + amount * 10
      return intToHex(sRGB.fromXYZ(LAB.toXYZ(lab)))
    },
    darkenColor (value, amount) {
      const lab = LAB.fromXYZ(sRGB.toXYZ(colorToInt(value)))
      lab[0] = lab[0] - amount * 10
      return intToHex(sRGB.fromXYZ(LAB.toXYZ(lab)))
    }
  },
  computed: {
    ...mapState({
      ratingColour: state => state.config.ratingColour,
      ratingAbbreviation: state => state.config.ratingAbbreviation
    }),
    materialColors () {
      return MaterialColors
    },
    ratingColorMap () {
      return {
        H: this.ratingColour[5],
        G: this.ratingColour[4],
        P: this.ratingColour[3],
        L: this.ratingColour[2],
        V: this.ratingColour[1],
        N: this.ratingColour[0]
      }
    },
    ratingAbbreviationMap () {
      return {
        H: this.ratingAbbreviation[5],
        G: this.ratingAbbreviation[4],
        P: this.ratingAbbreviation[3],
        L: this.ratingAbbreviation[2],
        V: this.ratingAbbreviation[1],
        N: this.ratingAbbreviation[0]
      }
    },
    chartColors () {
      return [
        this.materialColors.red.base,
        this.materialColors.blue.base,
        this.materialColors.yellow.base,
        this.materialColors.green.base,
        this.materialColors.orange.base,
        this.materialColors.purple.base,
        this.materialColors.indigo.base,
        this.materialColors.lightBlue.base,
        this.materialColors.brown.base,
        this.materialColors.grey.base,
        this.materialColors.lightGreen.base,
        this.materialColors.amber.base,
        this.materialColors.blueGrey.base,
        this.materialColors.deepOrange.base,
        this.materialColors.teal.base,
        this.materialColors.pink.base,
        this.materialColors.deepPurple.base,
        this.materialColors.cyan.base,
        this.materialColors.lime.base,
        this.materialColors.teal.accent3
      ]
    },
    logicColours () {
      return [
        this.materialColors.red.base,
        this.materialColors.blue.base,
        this.materialColors.green.base,
        this.materialColors.orange.base,
        this.materialColors.purple.base,
        this.materialColors.brown.base,
        this.materialColors.grey.base,
        this.materialColors.indigo.base,
        this.materialColors.lightBlue.base,
        this.materialColors.amber.base,
        this.materialColors.blueGrey.base,
        this.materialColors.deepOrange.base
      ]
    }
  }
}

export default Colors



// WEBPACK FOOTER //
// ./src/mixins/Colors.js